var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Cookie'),_c('cHeader'),_c('div',[_c('router-view')],1),_c('cFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }